import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './BlogCard.scss';
import { LanguageContext } from '../../context/LanguageContext';
import OptimizedImage from '../OptimizedImage';
import useAnalytics from '../../hooks/useAnalytics';

const BlogCard = ({blog, index = 0}) => {
    const { t, currentLang } = useContext(LanguageContext);
    const { img, url, title, categories, id } = blog;
    const { trackEvent, trackBlogCardClicked } = useAnalytics();
    
    // Blog sayfasına giden URL'yi oluştur
    const blogUrl = currentLang === 'en' 
        ? `/en/blog/${url}` 
        : `/blog/${url}`;
    
    // Debug logları kaldırıldı
    
    // Bloglar sayfasına giden URL'yi oluştur
    const blogsUrl = currentLang === 'en' ? '/en/blogs' : '/blogs';
    
    // Kategori adını belirle
    const categoryName = categories && categories.length > 0 
        ? categories[0].name 
        : t('blogs.defaultCategory');
    
    // Her kart için index'e göre sabit random tarih üret (her renderda değişmesin diye)
    const seededRandom = (seed) => {
        var x = Math.sin(seed + 1) * 10000;
        return x - Math.floor(x);
    };
    const getSeededDate = (seed) => {
        const year = new Date().getFullYear();
        const start = new Date(year, 0, 1).getTime();
        const end = new Date(year, 11, 31).getTime();
        const randomTime = start + seededRandom(seed) * (end - start);
        return new Date(randomTime);
    };
    const randomDate = getSeededDate(index);
    const date = {
        day: randomDate.getDate(),
        month: randomDate.toLocaleString(currentLang === 'en' ? 'en-US' : 'tr-TR', { month: 'short' })
    };

    const handleBlogClick = (source) => {
        // Eski event (geriye dönük uyumluluk için)
        trackEvent('blog_post_click', {
            blog_id: id || url,
            blog_title: title,
            source: source || 'blog_list',
        });
        
        // Yeni funnel event
        trackBlogCardClicked(id || url, title, source || 'blog_list');
    };

    return (
        <div className='col-lg-4 col-md-6 col-sm-6'>
            <div className="blog-card">
                <div className="blog-img">
                    <Link to={blogUrl} onClick={() => handleBlogClick('image')}>
                        <OptimizedImage 
                            src={img || '/logo192.png'} 
                            alt={title || t('altText.blog')}
                        />
                    </Link>
                    <div className="date">
                        <h6>{date.day}</h6>
                        <p>{date.month}</p>
                    </div>
                </div>
                <div className="blog-text">
                    <span><Link to={blogsUrl}>{categoryName}</Link></span>
                    <h3><Link to={blogUrl} onClick={() => handleBlogClick('title')}>{title}</Link></h3>
                </div>
            </div>
        </div>
    );
};

export default BlogCard;